export default "__VITE_ASSET__d191d826__$_?react__"